const FORGOT_PASSOWRD_CONTEXT = 'forgotPassword';

function loadSecurityQuestions(deps, model, username, captchaToken) {
  return deps.restSrv.list(FORGOT_PASSOWRD_CONTEXT, model.session.rest.auth.securityQuestions.url, { username, captchaToken }).then((data) => {
    model.forgotPassword.securityQuestions = data.questions;
    return model;
  });
}

export default {
  loadSecurityQuestions
};



// WEBPACK FOOTER //
// ./src/modules/security/logic/security.js